import { VoucherState } from "../../../services/voucher";
export const getImg = (language) => {
    const REDEEMEDSTAMP = {
        "en": "https://i.ezbuy.sg/FphReuXh0Mlz5p31rqKnznJh6NWi",
        "zh": "https://i.ezbuy.sg/FvX7n8oLj1ZguZHRnM8ZmFy7xS4d",
        "zhtw": "https://i.ezbuy.sg/FtdIBG5KlKRUqN3o7nhFMRFkUBtU",
        "th": "https://i.ezbuy.sg/Fh_CcwdheqiunIPlT_Vr2EAg-DqH",
        "ms": "https://i.ezbuy.sg/Fqx0LXcGPYtwLLKkcOT-uWvieEsc"
    };
    return REDEEMEDSTAMP[language];
};
export const getShowVoucherImgType = (voucher) => {
    const isExhaust = voucher.voucherState === VoucherState.ComingSoon;
    const isExpired = voucher.voucherState === VoucherState.Expired;
    const isClaimed = voucher.voucherState === VoucherState.RanOut;
    return {
        isExhaust,
        isExpired,
        isClaimed,
    };
};
